import SignInComponent from "../../components/auth/SignIn";
import useAuth from "../../hooks/useAuth";
import logoBlack from "../../vendor/logo_black.svg";
import logoWhite from "../../vendor/logo_white.svg";
import { Paper, Typography } from "@mui/material";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";

const Brand = styled("img")`
  width: 250px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignIn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signIn } = useAuth();
  const theme = useMuiTheme();
  const brandSrc = theme.palette.mode === "dark" ? logoWhite : logoBlack;
  const returnToParam = searchParams.get("returnTo");
  const returnTo =
    returnToParam?.startsWith("/") && !returnToParam.startsWith("//")
      ? returnToParam
      : "/";

  return (
    <React.Fragment>
      <Brand alt="Podium" src={brandSrc} />
      <Wrapper>
        <Helmet title="Sign In" />
        <Typography component="h2" variant="body1" align="center">
          Sign in to your account to continue
        </Typography>

        <SignInComponent
          onSubmit={async (
            values,
            { setErrors, setFieldValue, setStatus, setSubmitting }
          ) => {
            try {
              await signIn(
                values.email,
                values.password,
                values.turnstileToken
              );

              navigate(returnTo);
            } catch (error) {
              const message = error.message || "Something went wrong";

              setStatus({ success: false });
              setFieldValue("turnstileToken", "", false);
              setErrors({
                submit: message,
                turnstileToken: "Please verify again.",
              });
              setSubmitting(false);
            }
          }}
        />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
